import React from "react"
import SimpleBar from "simplebar-react"
import { Button, Collapse } from "@/shared/components"
import { Arrow } from "../ui/icons"

interface Props {
  children: React.ReactNode
}

interface State {
  hasError: boolean
  errorText: string
  stack?: string | null
}

// eslint-disable-next-line react-refresh/only-export-components
const ErrorPage = ({ errorText, stack }: Omit<State, "hasError">) => {
  const [isOpen, setIsOpen] = React.useState(false)
  return (
    <div className="flex h-[100vh] flex-col items-center bg-paper pt-28">
      <img src="/assets/Images/error-tab.svg" alt="error" className="mx-auto w-80" />
      <div className="flex w-max items-center justify-between gap-4 rounded-lg bg-red-100 px-4 py-2 text-red-600" onClick={() => setIsOpen(!isOpen)}>
        <h1 className="text-lg">ERROR: {errorText}</h1>
        <Arrow className="rounded-lg border bg-red-300 text-red-800" />
      </div>
      <SimpleBar style={{ maxHeight: "50vh", minWidth: "90vw" }} className="flex flex-col items-center">
        <Collapse in={isOpen} className="mt-4">
          <pre>{stack}</pre>
        </Collapse>
      </SimpleBar>
      <div className="flex justify-center gap-3">
        <Button onClick={() => window.location.reload()} className="mt-4" color="info">
          Reload
        </Button>
        <Button onClick={() => window.history.back()} className="mt-4">
          Go Back
        </Button>
      </div>
    </div>
  )
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, errorText: "", stack: "" }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    this.setState({ errorText: error.message, stack: info.componentStack })
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage errorText={this.state.errorText} stack={this.state.stack} />
    }
    return this.props.children
  }
}
